import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./ToolTipGuideLine.module.scss";
import ToolTipCard from "./ToolTipCard";
import { updateToolTip } from "../../../api/CommonAPI";
import { connect } from "react-redux";
import {
  getFromLocalStorage,
  setInLocalStorage,
} from "../../../common/utility";

const TrainingToolTip = ({ pageTitle, user, commonConfig }) => {
  const [show, setShow] = useState(false);
  const [currentStep, setCurrentStep] = useState();
  const [toolTips, setToolTips] = useState([]);
  const [targetComponent, setTargetComponent] = useState();
  const [backDrop, setBackDrop] = useState(true);
  const [searchParams] = useSearchParams();
  const tabName = searchParams.get("tabName");
  const { toolTipUsage } = user || {};
  const { ToolTipConfig } = commonConfig || {};
  const toolTip = getFromLocalStorage("lco", "ToolTip") || {};

  const updateToolTipViews = async () => {
    const payload = {
      toolTipName: document.title,
    };
    await updateToolTip(payload);
  };

  const renderTargetComponent = (toolTips, currentStep, backDrop) => {
    if (toolTips[currentStep]) {
      const { targetId } = toolTips[currentStep];
      const targetComponent = document.querySelector(
        `[data-target-id="${targetId}"]`
      );
      if (targetComponent) {
        setTargetComponent(targetComponent);
        setShow(true);
        setBackDrop(backDrop);
        setCurrentStep(currentStep);
      } else {
        setShow(false);
        setBackDrop(backDrop);
      }
    }
  };

  const handleDashboardTooltip = () => {
    const { firstVisit } = toolTip;
    const { views_limit } = (ToolTipConfig && ToolTipConfig[pageTitle]) || {};
    if (
      !firstVisit &&
      toolTipUsage &&
      (!toolTipUsage[pageTitle] || toolTipUsage[pageTitle] < views_limit) &&
      pageTitle === "Dashboard"
    ) {
      updateToolTipViews();
      setInLocalStorage("lco", "ToolTip", { firstVisit: true });
    }
  };

  const handleOk = () => {
    setShow(false);
    setInLocalStorage("lco", "ToolTip", { ...toolTip, [pageTitle]: true });
    pageTitle !== "Dashboard" && updateToolTipViews();
  };

  useEffect(() => {
    setShow(false);
    handleDashboardTooltip();
    //Only Temporary, settimeout will be removed later(currently used to defer tooltip load )
    setTimeout(() => {
      if (ToolTipConfig && toolTipUsage) {
        const {
          toolTips,
          views_limit,
          backDrop = true,
        } = (pageTitle && ToolTipConfig[pageTitle]) || {};
        if (
          toolTips &&
          toolTipUsage &&
          !toolTip[pageTitle] &&
          (!toolTipUsage[pageTitle] || toolTipUsage[pageTitle] < views_limit)
        ) {
          setToolTips(toolTips);
          renderTargetComponent(toolTips, 0, backDrop);
        }
      }
    }, 1000);
    // eslint-disable-next-line
  }, [pageTitle, ToolTipConfig, toolTipUsage, tabName]);

  return (
    <div className={styles.toolTipWrapper}>
      {show && backDrop && <div className={styles.backDrop}></div>}
      {show && (
        <ToolTipCard
          {...toolTips[currentStep]}
          handleNext={() =>
            renderTargetComponent(toolTips, currentStep + 1, backDrop)
          }
          handleOk={() => handleOk()}
          targetComponent={targetComponent}
          toolTips={toolTips}
          currentStep={currentStep}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userDetails,
    commonConfig: state.commonConfigData,
  };
};
export default connect(mapStateToProps)(TrainingToolTip);
